import React, { useState, useMemo, useEffect } from 'react';
import { UserVoice } from '@styled-icons/boxicons-solid/UserVoice';
import { Anchor } from 'grommet';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

import InviteUserLayer from './components/InviteUserLayer';
import EventEmitter from 'granite-admin/utils/event-emitter';
import { useToast } from 'granite-admin/core/components/Toast';
import MenuButton from 'granite-admin/core/components/MenuButton';
import { withTheme } from 'styled-components';
import { userInvitation } from 'granite-admin/accounts/controllers/user';
import { env } from 'granite-admin/env';
const projectName = env.REACT_APP_PROJECT_NAME || process.env.REACT_APP_PROJECT_NAME || 'Granite';
const InviteUser = ({
  isCollapsed,
  hoverIndicatorOptions,
  theme,
  inFooter
}) => {
  const {
    successToast,
    errorToast
  } = useToast();
  const eventEmitter = useMemo(() => new EventEmitter(), []);
  const [layer, setLayer] = useState(false);
  useEffect(() => {
    const subscription = eventEmitter.getObservable().subscribe(event => {
      switch (event.type) {
        case 'INVITE_SUCCESS':
          successToast('Invite sent successfully');
          break;
        case 'INVITE_FAILURE':
          errorToast(event?.data ?? 'Failed to invite!!');
          break;
        default:
          console.log('Not handled', event);
          break;
      }
    });
    return () => subscription.unsubscribe();
  }, [eventEmitter, successToast, errorToast]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, inFooter ? /*#__PURE__*/React.createElement(Anchor, {
    onClick: () => setLayer('INVITE-USER'),
    label: "Refer Us"
  }) : /*#__PURE__*/React.createElement(MenuButton, {
    isCollapsed: isCollapsed
    // label={`Refer ${projectName}`}
    ,
    label: "Refer Us",
    hoverIndicatorOptions: hoverIndicatorOptions,
    icon: /*#__PURE__*/React.createElement(UserVoice, {
      size: "22px",
      color: theme.global.colors['sidebar-svg']
    }),
    onClick: () => setLayer('INVITE-USER')
  }), layer === 'INVITE-USER' && /*#__PURE__*/React.createElement(InviteUserLayer, {
    setLayer: setLayer,
    userInvitation: userInvitation,
    eventEmitter: eventEmitter
  }));
};
InviteUser.propTypes = {
  isCollapsed: PropTypes.bool,
  hoverIndicatorOptions: PropTypes.object
};
export default withTheme(InviteUser);